import { EnglishLabels, Regisration_Form_Labels_English } from "./constants/englishLabels";
import { HindiLabels, Regisration_Form_Labels_Hindi } from "./constants/hindiLabels";
import { Input, Text, VStack } from "@chakra-ui/react";

import { toCamelCase } from "src/utils/globalUtils";
import { useState } from "react";

interface EmailInputProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  isRequired?: boolean;
  isDisabled?: boolean;
  isHindiLabels?: boolean;
  setIsEmailValid?: (isInvalid: boolean) => void;
}

export const EmailInput: React.FC<EmailInputProps> = ({
    label,
    value = "",
    onChange,
    isRequired = false,
    isDisabled = false,
    isHindiLabels = false,
    setIsEmailValid,
}) => {
    const [isEmailInValid, setIsEmailInValid] = useState(false);
    const [touched, setTouched] = useState(false);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const evaluateEmail = (val: string, markTouched = false) => {
        const valid = emailRegex.test(val);
        setIsEmailValid?.(valid);
        setIsEmailInValid((markTouched || touched) && !valid);
        if (markTouched) {
            setTouched(true);
        }
    };

    return (
    <VStack width="100%" alignItems="center" spacing={1}>
        {label && <Text>{label}</Text>}
        <Input
            value={value}
            isInvalid={isEmailInValid}
            textColor={isEmailInValid ? "#E53E3E" : "black"}
            onBlur={() => evaluateEmail(value, true)}
            background="rgba(108, 117, 125, 0.08)"
            borderColor="transparent"
            className="form-input"
            onChange={(e) => {
                onChange?.(e.target.value);
                evaluateEmail(e.target.value);
            }}
            placeholder={
            isHindiLabels
                ? HindiLabels.Enter_Email
                : EnglishLabels.Enter_Email
            }
            isRequired={isRequired}
            isDisabled={isDisabled}
        />
        {isEmailInValid && (
            <Text color="#E53E3E">
            {isHindiLabels
                ? `${Regisration_Form_Labels_Hindi.EMAIL_ID} अमान्य`
                : `Invalid ${toCamelCase(Regisration_Form_Labels_English.EMAIL_ID)}`}
            </Text>
        )}
    </VStack>
);};